class QhAtvExtra {
  constructor(dados) {
    this.id = dados ? dados.id : null;
    this.idQhPlano = dados ? dados.idQhPlano : null;
    this.data = dados ? dados.data : null;
    this.descricao = dados ? dados.descricao : null;
    this.qtdeHora = dados ? dados.qtdeHora : null;
    this.idsFuncionariosParticipantes = dados && dados.idsFuncionariosParticipantes
      ? dados.idsFuncionariosParticipantes
      : [];
  }

  static validations(required, maxLength, integer, minValue) {
    return {
      data: { required },
      descricao: { required, maxLength: maxLength(50) },
      qtdeHora: { required, integer, minValue: minValue(1) }
    };
  }

  static validationMessages() {
    return {
      data: { required: "Data é obrigatória" },
      descricao: {
        required: "Descrição é obrigatória",
        maxLength: "Descrição só aceita no máximo 50 caracteres"
      },
      qtdeHora: {
        required: "Quantidade de horas é obrigatória",
        integer: "Quantidade de horas deve ser um número inteiro",
        minValue: "Quantidade de horas deve ser maior que zero"
      }
    };
  }
}
export default QhAtvExtra;
